import { ApplicationOperPostParams } from '@lk/api/application/models/oper/oper_post-params.model'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'

export const applicationOperSend = createAsyncThunk<any, ApplicationOperPostParams, ThunkApi>(
  '[APPLICATION/OPER_POST] OPER_SEND',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.operPost('send', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)

export const applicationOperReturn = createAsyncThunk<any, ApplicationOperPostParams, ThunkApi>(
  '[APPLICATION/OPER_POST] OPER_RETURN',
  async ({ ...params }, { extra, rejectWithValue }) => {
    const result = await extra.api.application.operPost('return', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error.message)
  },
)
